module.exports = __webpack_public_path__ + "img/rbcn_pro_4.54eac07b.png";